<template>
	<div>
		<div class="ft20 cl-main ftw600">模板管理</div>
		
		<div class="mt20">
			<div class="bg-w">
				<a-layout>
					<a-layout-header class="layout-classes-header">
						<a-menu class="classes-menu" :defaultSelectedKeys="[selectCurrent]" @click="selectMenu" mode="horizontal">
							<a-menu-item key="project">模板列表</a-menu-item>
							<a-menu-item key="type">分类列表</a-menu-item>
						</a-menu>
					</a-layout-header>
					<a-layout-content class="layout-classes-content">
						<div v-if="selectCurrent == 'project'">
							<project-list></project-list>
						</div>
						<div v-if="selectCurrent == 'type'">
							<type-list></type-list>
						</div>
						
					</a-layout-content>
				</a-layout>
			</div>
		</div>
	</div>
</template>

<script>
	import projectList from './components/template/template.vue';
	import typeList from './components/template/type.vue';
	export default{
		components:{
			projectList,
			typeList
		},
		data(){
			return {
				selectCurrent:'project',
			}
		},
		methods:{
			selectMenu(e) {
				this.selectCurrent = e.key;
			},
		}
	}
</script>

<style>
	.layout-classes-header {
		background: #FFFFFF;
	}
	
	.layout-classes-header {
		padding: 0 20px;
		height: 58px;
		line-height: 57px;
		border-bottom: 1px solid #F0F3F5;
		width: 100%;
	}
	
	.layout-classes-content {
		padding: 0px 0px 10px 0px;
		background: #FFFFFF;
		width: 100%;
		min-height: 700px;
	}
	
	.classes-menu {
		border-bottom: none;
		line-height: 55px;
		font-size: 14px;
	}
</style>
